<template>
  <div class="menu" v-resize="handleResize">
    <el-drawer
      custom-class="menu"
      direction="rtl"
      :size="250"
      :visible.sync="drawer"
      :append-to-body="true"
    >
      <!-- 主菜单 -->
      <el-divider>{{ $t('common.mainMenu') }}</el-divider>
      <div
        class="menu-click"
        :style="{ color: currentPage === item.path ? '#0056D2' : '#222' }"
        v-for="item in publicList"
        :key="item.name"
        @click="jumpPage(item.path)"
      >
        {{ item.name }}
      </div>
      <!-- 个人中心 -->
      <el-divider>{{ $t('common.personalCenter') }}</el-divider>
      <!-- 退出登录 -->
      <div class="menu-click" @click="handleCommand('exit')">{{ $t('common.logout') }}</div>
      <!-- 修改密码 -->
      <div class="menu-click" @click="handleCommand('password')">{{ $t('common.changePassword') }}</div>
      <div class="menu-click" @click="handleCommand('userMessage')">
        <!-- 用户留言 -->
        {{ $t('common.userMessage') }}
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { menuMix } from "@/mixins/menuMix";
import { debounce } from "@/utils/util";

export default {
  name: "xMenu",
  mixins: [menuMix],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleResize: debounce(function () {
      if (document.body.clientWidth > 991 && this.drawer) {
        this.drawer = false;
      }
    }, 500),
    openMenu() {
      this.drawer = true;
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .menu {
  .el-drawer__header {
    margin-bottom: 0;
  }
  .el-drawer__body {
    padding: 0 20px;
    .menu-click {
      cursor: pointer;
      margin-top: 10px;
    }
    .menu-click:hover {
      color: $mainColor !important;
    }
  }
}
</style>
